import React from 'react';
import PropTypes from 'prop-types';
import SelectBox from '../../SelectBox';

const SelectPrice = ({ t, period, updateContent, freeCourse, localStyles, periods }) => (
  <>
    <SelectBox
      dropdownClassName={localStyles.dropSelect}
      value={period || t}
      label={t('category')}
      placeholder={t('course.edit.price.period')}
      onChange={data => updateContent('period', data)}
      disabled={freeCourse}
      options={periods.map(item => ({ id: item.value, value: item.title }))}
    />
  </>
);

SelectPrice.propTypes = {
  period: PropTypes.string,
  updateContent: PropTypes.func,
  t: PropTypes.func,
  freeCourse: PropTypes.bool,
  localStyles: PropTypes.object,
  periods: PropTypes.array,
};

SelectPrice.defaultProps = {
  period: '',
  updateContent: () => {},
  t: () => {},
  freeCourse: false,
  localStyles: {},
  periods: '',
};

export default SelectPrice;
